export const EXTENSION_ACTIVITIES_ROUTES = {
  FILE_UPLOAD: '',
  RENAME_FILE: 'rename-file/:fileId',
  VIEW_FILES: 'view-files',
};
